import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/movies";
import { TYPE_LABEL, formatDate } from "@/lib/media";

interface MovieCardProps {
  item: MediaItem;
  variant?: "grid" | "row";
}

export default function MovieCard({ item, variant = "grid" }: MovieCardProps) {
  if (variant === "row") {
    return (
      <Link
        to={`/detail/${item.id}`}
        className="group flex gap-3 md:gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
      >
        <div className="relative h-[132px] w-[92px] shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[150px] md:w-[104px]">
          <img
            src={item.cover}
            alt={`${item.title} 封面海报`}
            title={`${item.title} 中文字幕资源`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2">
            <span
              className={`rounded-full px-2 py-0.5 text-xs ${
                item.type === "movie"
                  ? "bg-primary-100 text-primary-700"
                  : "bg-accent-100 text-accent-800"
              }`}
            >
              {TYPE_LABEL[item.type]}
            </span>
            <span className="text-xs text-foreground-400">{item.year}</span>
          </div>
          <h3 className="mt-2 truncate text-base font-medium text-foreground-950 group-hover:text-primary-600 md:text-lg">
            {item.title}
          </h3>
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500 md:text-sm">
            {item.summary}
          </p>
          <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-closed-captioning-line text-accent-600"></i>中文字幕已更新
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {formatDate(item.updatedAt)}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 封面海报`}
          title={`${item.title} 中文字幕资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur">
          {TYPE_LABEL[item.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-foreground-950/60 px-1.5 py-0.5 text-xs font-medium text-accent-300 backdrop-blur">
          <i className="ri-star-fill"></i>
          {item.rating}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {item.summary}
        </p>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-400">
          <span>{item.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {item.updatedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}